<template>
  <a-select
    mode="tags"
    :placeholder="placeholder"
    :open="opened"
    :disabled="disabled"
    :default-value="[]"
    :value="value"
    class="custom-input"
    style="width: 80%"
    ref="selector"
    @focus="onFocus"
    @blur="onBlur"
    @change="onChangeWrapper"
  >
    <a-select-option
      v-for="opt in options"
      :value="opt.id"
      :key="`${opt.id}`">
      {{ opt.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import ASelect from 'ant-design-vue/lib/select'

export default {
  name: 'm-select',
  components: {
    ASelect,
    'a-select-option': ASelect.Option,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    onChangeValues: {
      type: Function,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: () => '',
    },
  },
  data () {
    return {
      opened: false,
    }
  },
  methods: {
    onFocus () {
      this.opened = true
    },
    onBlur () {
      this.opened = false
    },
    onChangeWrapper (value) {
      this.onChangeValues(value)
      this.$refs.selector.blur()
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/select/style/index.css';
  @import 'scss/variables';

  .ant-select {
    padding-bottom: 0.313em;
    -webkit-text-fill-color: $field-color-text; // autofill hack
    width: 90%;
    background: none;
    border: none;
    caret-color: $field-color-focused;
    color: $field-color-text;

    @include material-border($field-color-focused, $field-color-unfocused);
  }

</style>
